
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Mumbaitomahabaleshwar() {



    const cardData =
    {
        keyword: 'Mumbai to Mahabaleshwar Cab ',
        heading: 'Skyline Cabs:  Mumbai to Mahabaleshwar Cab ',
        headingDescription: 'Skyline Cabs offers reliable and comfortable Mumbai to Mahabaleshwar Cab service for a refreshing hill station getaway. Whether you are planning a family vacation, romantic trip, or a peaceful solo retreat, our clean and well-maintained vehicles with professional drivers ensure a safe and pleasant journey. Enjoy scenic views, on-time pickups from anywhere in Mumbai, transparent fares, and 24/7 customer support. Book your Mumbai to Mahabaleshwar cab with Skyline Cabs today and travel to the hills in comfort and style.',

        top: 'Top Places to Visit in Mumbai with Skyline Cabs',

"topPlaces": [
    {
        "title": "Venna Lake",
        "description": "A scenic man-made lake surrounded by lush greenery, Venna Lake is a popular spot for boating, horse riding, and enjoying street food. It’s a great place to relax with family and admire the tranquil waters and nearby hills."
    },
    {
        "title": "Elephant’s Head Point",
        "description": "Shaped like an elephant’s head, this viewpoint offers breathtaking views of the Sahyadri mountain ranges and the valley below. It’s especially popular for its peaceful surroundings and dramatic rock formations."
    },
    {
        "title": "Arthur’s Seat",
        "description": "Known as the ‘Queen of All Points,’ Arthur’s Seat offers panoramic views of the deep valleys of the Savitri River. It’s famous for its gravity-defying phenomenon where light objects seem to roll uphill."
    },
    {
        "title": "Mapro Garden",
        "description": "A popular tourist attraction near Mahabaleshwar, Mapro Garden is known for its strawberry produce, delicious food, chocolate factory, and retail outlet. It's a must-visit for those who enjoy fresh fruit-based treats."
    },
    {
        "title": "Pratapgad Fort",
        "description": "Located about 20 km from Mahabaleshwar, Pratapgad Fort is a historic hill fort known for the famous battle between Shivaji Maharaj and Afzal Khan. It offers rich history, panoramic views, and impressive architecture."
    },
    {
        "title": "Lingmala Waterfall",
        "description": "One of the most stunning waterfalls in the region, Lingmala Waterfall cascades from a height of over 500 feet. Best visited during monsoon, it offers lush green surroundings and a breathtaking view."
    },
    {
        "title": "Wilson Point",
        "description": "The highest point in Mahabaleshwar, Wilson Point is also known as Sunrise Point. It has three watchtowers offering a 360-degree view of the surrounding hills and valleys, making it ideal for early morning visits."
    },
    {
        "title": "Mahabaleshwar Temple",
        "description": "Dedicated to Lord Shiva, this ancient temple is considered highly sacred and features a self-originated Shiva Lingam. It's an important pilgrimage site and a peaceful spot for spiritual seekers."
    },
    {
        "title": "Bombay Point (Sunset Point)",
        "description": "One of the oldest viewpoints in Mahabaleshwar, Bombay Point offers spectacular sunset views over the valleys. It’s a favorite evening spot for tourists and locals alike."
    },
    {
        "title": "Panchganga Temple",
        "description": "This temple is unique for being the confluence of five rivers – Krishna, Venna, Koyna, Savitri, and Gayatri. It is both a spiritual and architectural marvel, attracting pilgrims throughout the year."
    }
],

"services": [
    {
      "name": "Mumbai to Mahabaleshwar Cab",
      "description": "Book a comfortable and hassle-free cab service from Mumbai to Mahabaleshwar with Skyline Cabs. Enjoy a scenic drive to this popular hill station in the Western Ghats with well-maintained vehicles and experienced drivers."
    },
    {
      "name": "Mumbai to Mahabaleshwar Taxi Service",
      "description": "Skyline Cabs offers reliable taxi services from Mumbai to Mahabaleshwar. Whether it’s a family vacation, a corporate trip, or a romantic getaway, our taxis ensure a smooth, safe, and enjoyable journey."
    },
    {
      "name": "Mumbai to Mahabaleshwar Cab Booking",
      "description": "Easily book your Mumbai to Mahabaleshwar cab with Skyline Cabs for the most competitive rates. Choose from a range of vehicle options to suit your group size, including sedans, SUVs, and more."
    },
    {
      "name": "Taxi Fare from Mumbai to Mahabaleshwar",
      "description": "Skyline Cabs offers transparent and affordable taxi fares for the Mumbai to Mahabaleshwar journey. Pricing is based on distance, type of vehicle, and travel duration, with no hidden charges."
    },
    {
      "name": "Mumbai to Mahabaleshwar One Way Cab",
      "description": "For those planning a one-way trip from Mumbai to Mahabaleshwar, Skyline Cabs offers a dedicated one-way taxi service. Save on return trip fares while enjoying a comfortable ride."
    },
    {
      "name": "Mahabaleshwar Taxi Service from Mumbai",
      "description": "Whether it’s your first visit to Mahabaleshwar or a regular trip, Skyline Cabs provides a seamless taxi service from Mumbai, ensuring you reach your destination with comfort and convenience."
    }
  ],
  "tableData": [
    ["Mumbai to Mahabaleshwar Cab", "Mumbai to Mahabaleshwar Taxi Service"],
    ["Mumbai to Mahabaleshwar Cab Booking", "Taxi Fare from Mumbai to Mahabaleshwar"],
    ["Mumbai to Mahabaleshwar One Way Cab", "Mahabaleshwar Taxi Service from Mumbai"]
  ],



  whychoose: [
    {
        "WhyChooseheading": "Reliable Mumbai to Mahabaleshwar Cab Service",
        "WhyChoosedescription": "Enjoy a hassle-free and reliable Mumbai to Mahabaleshwar cab service, ensuring a comfortable ride to the serene hill station known for its scenic views and pleasant climate."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Cabs",
        "WhyChoosedescription": "Our cabs offer spacious interiors and ample legroom, ensuring a comfortable journey for you and your family or group as you travel to Mahabaleshwar."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "We provide affordable pricing for Mumbai to Mahabaleshwar trips with transparent charges. No hidden costs, just a simple and budget-friendly travel experience."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our drivers are well-trained, experienced, and familiar with the routes to Mahabaleshwar. They ensure a safe and smooth journey while guiding you through the best routes."
    },
    {
        "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
        "WhyChoosedescription": "Our vehicles are regularly serviced, cleaned, and sanitized to ensure a safe, hygienic, and comfortable ride to Mahabaleshwar."
    },
    {
        "WhyChooseheading": "Flexible Travel Packages",
        "WhyChoosedescription": "Whether you're planning a one-day trip or an extended stay, we offer flexible packages for your Mumbai to Mahabaleshwar journey, allowing you to customize your travel experience."
    },
    {
        "WhyChooseheading": "24/7 Customer Support and Easy Booking",
        "WhyChoosedescription": "Book your Mumbai to Mahabaleshwar cab easily through our website or customer support, available 24/7. Enjoy instant booking confirmation and a seamless experience."
    },
    {
        "WhyChooseheading": "Ideal for Family, Friends, and Couples",
        "WhyChoosedescription": "Our cabs are perfect for family outings, trips with friends, or romantic getaways to Mahabaleshwar, offering both comfort and a smooth journey throughout the trip."
    }
]






    }

    const faqData = [
        {
            id: 1,
            question: 'How can I book a cab from Mumbai to Mahabaleshwar with Skyline Cabs?',
            answer:
                'Booking a cab from Mumbai to Mahabaleshwar is simple with Skyline Cabs. You can book through our website, mobile app, or by calling our customer support. Just enter your pickup location, destination, travel date, and select your preferred vehicle.',
        },
        {
            id: 2,
            question: 'What is the distance and travel time from Mumbai to Mahabaleshwar?',
            answer:
                'The distance from Mumbai to Mahabaleshwar is approximately 260 km, and the journey typically takes around 5 to 6 hours depending on traffic and weather conditions.',
        },
        {
            id: 3,
            question: 'What types of vehicles are available for the Mumbai to Mahabaleshwar trip?',
            answer:
                'We offer a range of vehicles including Swift Dzire, Ertiga, Innova Crysta, Kia Carens, and SUVs for this route. For group travel, Tempo Travellers and Force Urbania are also available.',
        },
        {
            id: 4,
            question: 'Are your cab fares for Mumbai to Mahabaleshwar fixed?',
            answer:
                'Yes, we offer fixed and transparent fares that include fuel, tolls, taxes, and driver charges. You’ll know the total price before confirming your booking.',
        },
        {
            id: 5,
            question: 'Can I book a one-way cab from Mumbai to Mahabaleshwar?',
            answer:
                'Yes, we offer convenient one-way cab options from Mumbai to Mahabaleshwar. You can also book a round-trip if you plan to return with us.',
        },
        {
            id: 6,
            question: 'Is the route from Mumbai to Mahabaleshwar safe for travel?',
            answer:
                'Yes, the route is safe and scenic. Our experienced drivers ensure a smooth and safe journey, even through the ghat sections and during monsoon travel.',
        },
        {
            id: 7,
            question: 'Are stopovers allowed during the journey?',
            answer:
                'Yes, short stopovers are allowed. If you wish to include sightseeing or food breaks, just inform the driver or mention it while booking.',
        },
        {
            id: 8,
            question: 'What payment options are available for this cab service?',
            answer:
                'We accept multiple payment methods including UPI, credit/debit cards, net banking, and cash payments after the trip.',
        },
        {
            id: 9,
            question: 'Can I cancel or modify my Mumbai to Mahabaleshwar cab booking?',
            answer:
                'Yes, you can cancel or modify your booking easily through our app, website, or by contacting customer support. We offer flexible options to accommodate changes.',
        },
        {
            id: 10,
            question: 'Why choose Skyline Cabs for travel from Mumbai to Mahabaleshwar?',
            answer:
                'Skyline Cabs offers well-maintained vehicles, professional drivers, affordable rates, and seamless booking. Our punctuality and focus on comfort make us the preferred choice for hill station travel.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Ramesh Verma",
            rating: 5,
            review: "We booked a cab from Mumbai to Mahabaleshwar for a weekend trip. The car was clean and spacious, and the driver was polite and knowledgeable about the route. Great service!"
        },
        {
            name: "Miss. Sonal Gupta",
            rating: 4,
            review: "The ride to Mahabaleshwar was very comfortable with Skyline Cabs. The driver handled the ghat roads well and even helped us with local tips. Highly recommended for outstation travel!"
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



   const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Mahabaleshwar Cab",
  "image": "https://skylinecabs.com/assets/images/mumbai-to-mahabaleshwar-cab.jpg",
  "description": "Book Mumbai to Mahabaleshwar cab with Skyline Cabs for a scenic and comfortable hill station getaway. Choose from AC sedans, SUVs, or luxury vehicles with experienced drivers — ideal for families, couples, and group tours.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8432"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3200",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/mumbai-to-mahabaleshwar-cab"
  }
};



      
     
    return (
        <div>

<Helmet>
  <title>Mumbai to Mahabaleshwar Cab | Hill Station Taxi Ride | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Mumbai to Mahabaleshwar cab with Skyline Cabs for a scenic and comfortable hill station getaway. Choose from AC sedans, SUVs, or luxury vehicles with experienced drivers — ideal for families, couples, and group tours." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to Mahabaleshwar Cab, Hill Station Taxi Mumbai, AC Cab to Mahabaleshwar, Mumbai to Mahabaleshwar Sedan, SUV Cab to Mahabaleshwar, Online Cab Booking Mumbai Mahabaleshwar, Skyline Cabs Mahabaleshwar Tour, Mumbai to Panchgani Taxi" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      

            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/81.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitomahabaleshwar;